export const tr = {
    'leningrad-region': 'St.Petersburg ve St.Petersburg bölgesi',
    'moscow-region': 'Moskova ve Moskova Oblastı',
    'russia-cis-georgia': 'Rusya, CIS ve Gürcistan',
    ukraine: 'Ukrayna'
};
